import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invoiceDeliveryDetails: {},
};

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setInvoiceDeliveryDetails: (state, action) => {
      state.invoiceDeliveryDetails = action.payload;
    },
  },
});

export const { actions } = invoicesSlice;
export default invoicesSlice.reducer;
